/**
 * BORDER RADIUS
 */

import { css } from "styled-components";

export enum BORDER_RADIUS {
  SM = "4px",
  MD = "8px",
  LG = "12px",
  XL = "16px",
  XXL = "20px",
}

/**
 * BOX SHADOW
 */

export enum BOX_SHADOW {
  XS = "0px 0px 32px 0px #231F200A",
  SM = "0px 0px 44px 20px #231F200F",
  MD = "0px 8px 8px rgba(0, 0, 0, 0.5)",
  LG = "0px 12px 12px rgba(0, 0, 0, 0.5)",
  XL = "0px 16px 16px rgba(0, 0, 0, 0.5)",
  XXL = "0px 20px 20px rgba(0, 0, 0, 0.5)",
  SOLID_SM = "0px 2px 0px rgba(0, 0, 0, 1)",
  SOLID_MD = "0px 5px 0px rgba(0, 0, 0, 1)",
}

export enum LIGHT_BOX_SHADOW {
  SM = "0px 4px 4px rgba(0, 0, 0, 0.3)",
  MD = "0px 8px 8px rgba(0, 0, 0, 0.3)",
  LG = "0px 12px 12px rgba(0, 0, 0, 0.3)",
  XL = "0px 16px 16px rgba(0, 0, 0, 0.3)",
  XXL = "0px 20px 20px rgba(0, 0, 0, 0.3)",
  SOLID_SM = "0px 2px 0px rgba(243, 243, 250, 1)",
  SOLID_MD = "0px 5px 0px rgba(243, 243, 250, 1)",
}

/**
 * Media Queries
 */

const size = {
  mobile: "480px",
  tablet: "768px",
  laptop: "1024px",
  desktop: "2560px",
};

const between = (min: string, max: string, inner: string) => css`
  @media (min-width: ${min}) and (max-width: ${max}) {
    ${inner};
  }
`;

export const mobile = (inner: string) => css`
  @media (max-width: ${size.mobile}) {
    ${inner};
  }
`;

export const tablet = (inner: string) =>
  between(size.mobile, size.tablet, inner);

export const laptop = (inner: string) =>
  between(size.tablet, size.laptop, inner);

export const desktop = (inner: string) =>
  between(size.laptop, size.desktop, inner);
